<template>
  <div class="stock-card ripple" @click="$emit('click' , quote.saleNum)">
    <div class="stock-card__content">
      <div class="stock-card_img">
        <h6>Order No. : #{{ quote.saleNum }} </h6>
        <h6 class="text-muted stock-card_company mb-2">{{ quote.Name }}</h6>
      </div>
      <div class="stock-card_info">
      </div>
    </div>
    <hr style="border: 1px black solid" />
    <div class="stock-card__footer">
      <div class="stock-card_stock-type">
        <h6 class="text-muted stock-card_company">{{ quote.created }}</h6>
        <p class="mb-0 fw-bold text-secondary">Total : {{ $utils.formatMoney(quote.Amount) }}</p>
      </div>
      <div>
        <p class="mb-0 stock-card_company text-muted">Debtor : {{ quote.customerName }} </p>
        <p class="mb-0 stock-card_company text-muted">Created By : {{ quote.User }} </p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "QuoteRecord",
  props: {quote: Object},
}
</script>

<style lang="scss" scoped>
.icon {
  font-size: 25px;
  margin: 10px;
}

p {
  margin: 0;

}

.stock-card_company {
  font-size: 12px;
}

.stock-card {
  background: #fff;
  padding: 6px 15px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
  border-bottom: 1px solid #d2d2d2;

  &__content {
    display: flex;
    align-items: center;
    //margin-bottom: 5px;

    .stock-card_img > .icon-img {
      font-size: 20px;

      img {
        height: 60px;
        width: 60px;
        opacity: 0.7;
        object-fit: contain;
        border-radius: 8px;
      }
    }

    .stock-card_info {
      flex: 1;

      .text-muted a {
        color: #777;
      }
    }
  }

  &__footer {
    display: flex;
    align-items: center;
    justify-content: space-between;

    .stock-card_stock-type {
      width: 60%;
    }

    .stock-card-price {
      font-weight: 500;
      font-size: 18px;
      color: #40434A;
    }
  }
}

.stock-label {
  display: inline-block;
  padding: 2px 12px;
  font-size: 10px;
  font-weight: 700;
  background: #f5f5f5;
  border: 1px solid #d2d2d2;
  border-radius: 5px;
  margin-right: 2px;
  color: #40434A;
}

h6, h4, p {
  margin: 0;
}
</style>
